//--------------- IMPORTAÇÕES ---------------//
import { Plus } from "lucide-react";
import { useContext } from "react";
import { TagsContext } from "../context/TagsContext";
import { createTagService, loadTagsService } from "../services";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function Main() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { tags, setTags } = useContext(TagsContext); // Estado que armazena a lista de Tags
    const { newTagName, setNewTagName } = useContext(TagsContext); // Estado que armazena a nova Tag



    //---------- FUNÇÃO ASSÍNCRONA CRIAR TAG --------//
    // Nesta função, é salva a nova Tag no Banco de Dados via API.
    async function handleCreateTag() {
        const response = await createTagService(newTagName);
        if (response) {
            setNewTagName("");
            handleRefreshTags();
        }
    };



    //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
        // Nesta função, é requisitado à API as TAGS armazenadas.
        // AS TAGS retornadas pela API são armazenadas no Estado "tags" .
        async function handleRefreshTags() {
            const response = await loadTagsService();
            if(response){
                setTags(response.data);
            }
        };



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* INPUT DO NOME DA NOVA TAG */}
            <input
                type="text"
                placeholder="Nova tag"
                value={newTagName}
                onChange={(e) => setNewTagName(e.target.value)}
                className="bg-surface-2 text-white p-2 rounded border border-white/[0.08] h-[40px]"
            />

            {/* BUTTON DE CRIAR NOVA TAG */}
            <button
                onClick={handleCreateTag}
                className="bg-brand-600 hover:bg-brand-700 p-2 rounded flex items-center gap-2 h-[40px]"
            >
                <Plus className="w-2 h-2" /> Nova Tag
            </button>

        </>
    )
}